import { styled } from "@mui/system";
import { Box } from "@mui/material";

export const FlexContainer = styled(Box)(({ theme }) => ({
  marginTop: "0",
  marginBottom: "0"
}));

export const RelativeBox = styled(Box)(({ theme }) => ({
  position: "relative"
}));

export const ButtonWrapper = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "flex-end",
  margin: "40px 0"
}));

export const Label = styled("p")(({ theme }) => ({
  marginBottom: 0,
  paddingLeft: 10,
  paddingRight: 10
}));
